var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isVisible)?_c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('div',{staticClass:"text",attrs:{"align":"center","valign":"middle"}},[_c('b',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ce5a2d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = null
// module chunks = 